import React from "react";

const UpperBlock = ({ icon, title, content }) => (
    <div className="p-6 upper-block text-center">
        <div className="p-5 bg-white border-radius">
            {icon && <div>{icon}</div>}
            {title && <h4 className="mt-6 mb-4">{title}</h4>}
            {content && <span className="d-block text-16">{content}</span>}
        </div>
    </div>
);

export default UpperBlock;
